/* ═══════════════════════════════════════════════════════════════
   SERMENT — MAISON MOTION
   Gentle life for a couture house: ornaments that draw themselves,
   a seal that turns with the scroll, a gold cursor, a thread of
   progress, a loupe on the lace, a soft tilt on the gowns, a short
   parchment curtain on arrival, and a wedding-date planner.
   Everything respects prefers-reduced-motion and touch screens.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var doc = document, body = doc.body;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  var ANIM = !reduce && !body.classList.contains('no-anim');
  var raf = window.requestAnimationFrame;

  /* ── 1. Ornaments that draw themselves ([data-draw]) ── */
  if ('IntersectionObserver' in window) {
    var drawIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-drawn'); drawIO.unobserve(en.target); }
      });
    }, { threshold: 0.25 });
    doc.querySelectorAll('[data-draw]').forEach(function (el) { drawIO.observe(el); });
  } else {
    doc.querySelectorAll('[data-draw]').forEach(function (el) { el.classList.add('is-drawn'); });
  }

  /* ── 2. Seals that turn with the scroll ── */
  var seals = doc.querySelectorAll('[data-seal]');
  if (seals.length && ANIM) {
    var sealTick = false;
    var turnSeals = function () {
      if (sealTick) return; sealTick = true;
      raf(function () {
        sealTick = false;
        var a = (window.scrollY * 0.06) % 360;
        seals.forEach(function (s) { s.style.transform = 'rotate(' + a + 'deg)'; });
      });
    };
    window.addEventListener('scroll', turnSeals, { passive: true });
    turnSeals();
  }

  /* ── 3. Gold cursor (desktop only): a dot, a lagging ring, "Discover" over the gowns ── */
  if (fine && ANIM) {
    var dot = doc.createElement('div'); dot.className = 'mcur-dot';
    var ring = doc.createElement('div'); ring.className = 'mcur-ring';
    var lab = doc.createElement('span'); lab.className = 'mcur-label'; ring.appendChild(lab);
    body.appendChild(dot); body.appendChild(ring);
    var mx = -100, my = -100, rx = -100, ry = -100, shown = false;
    doc.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY; kick();
      if (!shown) { shown = true; body.classList.add('mcur-on'); }
    }, { passive: true });
    doc.addEventListener('mouseleave', function () { body.classList.remove('mcur-on'); shown = false; });
    var loop = function () {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      dot.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px)';
      if (Math.abs(mx - rx) < 0.15 && Math.abs(my - ry) < 0.15) { running = false; return; }
      raf(loop);
    };
    var running = false;
    var kick = function () { if (!running) { running = true; raf(loop); } };
    kick();
    var hoverSel = 'a, button, [role="button"], label.v-pill, .ccard, .cr-card, .acc-tile, .mg-item, input, select, textarea';
    var labelSel = '.cr-card, .ccard, .acc-tile, .mg-item';
    doc.addEventListener('mouseover', function (e) {
      var t = e.target.closest ? e.target.closest(hoverSel) : null;
      body.classList.toggle('mcur-hover', !!t);
      var l = e.target.closest ? e.target.closest(labelSel) : null;
      if (l) { lab.textContent = l.getAttribute('data-cursor') || 'Discover'; body.classList.add('mcur-label-on'); }
      else { body.classList.remove('mcur-label-on'); }
    });
    doc.addEventListener('mousedown', function () { body.classList.add('mcur-down'); });
    doc.addEventListener('mouseup', function () { body.classList.remove('mcur-down'); });
  }

  /* ── 4. A thread of gold: reading progress on the right edge ── */
  if (fine && ANIM && body.classList.contains('template-index')) {
    var th = doc.createElement('div'); th.className = 'mthread';
    th.innerHTML = '<span class="mthread-fill"></span><span class="mthread-bead"></span>';
    body.appendChild(th);
    var fill = th.firstChild, bead = th.lastChild, thTick = false;
    var thread = function () {
      if (thTick) return; thTick = true;
      raf(function () {
        thTick = false;
        var max = doc.documentElement.scrollHeight - window.innerHeight;
        var p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
        fill.style.transform = 'scaleY(' + p + ')';
        bead.style.top = (p * 100) + '%';
        th.classList.toggle('on', window.scrollY > window.innerHeight * 0.6);
      });
    };
    window.addEventListener('scroll', thread, { passive: true });
    thread();
  }

  /* ── 5. The loupe: magnify the lace on the editorial ── */
  if (fine && ANIM) {
    doc.querySelectorAll('.couture-edito .ced-media img').forEach(function (img) {
      var host = img.closest('.couture-edito');
      if (!host) return;
      var loupe = doc.createElement('div'); loupe.className = 'mloupe';
      host.appendChild(loupe);
      host.classList.add('has-loupe');
      var Z = 2.2;
      var move = function (e) {
        var r = img.getBoundingClientRect();
        var x = e.clientX - r.left, y = e.clientY - r.top;
        if (x < 0 || y < 0 || x > r.width || y > r.height) { loupe.classList.remove('on'); return; }
        loupe.classList.add('on');
        var hr = host.getBoundingClientRect();
        loupe.style.left = (e.clientX - hr.left) + 'px';
        loupe.style.top = (e.clientY - hr.top) + 'px';
        loupe.style.backgroundImage = 'url("' + img.currentSrc + '")';
        /* the photo is object-fit: cover — work out the size it is really painted at */
        var nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height;
        var s = Math.max(r.width / nw, r.height / nh);
        var pw = nw * s, ph = nh * s, ox = (r.width - pw) / 2, oy = (r.height - ph) / 2;
        loupe.style.backgroundSize = (pw * Z) + 'px ' + (ph * Z) + 'px';
        loupe.style.backgroundPosition = ((ox - x) * Z + loupe.offsetWidth / 2) + 'px ' + ((oy - y) * Z + loupe.offsetHeight / 2) + 'px';
      };
      host.addEventListener('mousemove', move);
      host.addEventListener('mouseleave', function () { loupe.classList.remove('on'); });
    });
  }

  /* ── 6. A soft tilt on the gown cards ── */
  if (fine && ANIM) {
    doc.querySelectorAll('.cr-card, .acc-tile').forEach(function (card) {
      var vis = card.querySelector('.cr-visual') || card;
      card.addEventListener('mousemove', function (e) {
        var r = vis.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        vis.style.transform = 'perspective(900px) rotateX(' + (-py * 4) + 'deg) rotateY(' + (px * 4) + 'deg) translateZ(0)';
        vis.style.transition = 'transform .15s ease-out';
      });
      card.addEventListener('mouseleave', function () {
        vis.style.transition = 'transform .7s cubic-bezier(.2,.7,.2,1)';
        vis.style.transform = '';
      });
    });
  }

  /* ── 7. The curtain: a parchment veil with the seal, lifted once per visit ── */
  (function () {
    var seen = false;
    try { seen = sessionStorage.getItem('serment-curtain') === '1'; } catch (e) {}
    if (seen || !ANIM || !fine || !body.classList.contains('template-index')) return; /* no curtain on touch screens: speed first */
    var c = doc.createElement('div'); c.className = 'mcurtain';
    c.innerHTML = '<div class="mcurtain-seal"></div><div class="mcurtain-word">Serment</div>';
    body.appendChild(c);
    body.classList.add('mcurtain-on');
    var done = function () {
      c.classList.add('lift');
      body.classList.remove('mcurtain-on');
      try { sessionStorage.setItem('serment-curtain', '1'); } catch (e) {}
      setTimeout(function () { if (c.parentNode) c.parentNode.removeChild(c); }, 1400);
    };
    var go = function () { setTimeout(done, 900); };
    if (doc.readyState === 'complete') go(); else window.addEventListener('load', go);
    setTimeout(done, 3200); /* never trap the visitor */
  })();

  /* ── 8. Your wedding date: when would the gown arrive? ── */
  doc.querySelectorAll('[data-date-planner]').forEach(function (form) {
    var input = form.querySelector('input[type="date"]');
    var out = form.querySelector('[data-out]');
    var lead = parseInt(form.getAttribute('data-lead') || '14', 10);
    var tx = function (n, f) { return form.getAttribute(n) || f; };
    if (!input || !out) return;
    var lg = document.documentElement.lang || 'en'; if (lg === 'en') { lg = 'en-GB'; }
    var fmt = function (d) { return d.toLocaleDateString(lg, { day: 'numeric', month: 'long', year: 'numeric' }); };
    var min = new Date(); input.min = min.toISOString().slice(0, 10);
    var update = function () {
      if (!input.value) { out.textContent = ''; out.className = 'rdv-date-out'; return; }
      var wedding = new Date(input.value + 'T12:00:00');
      var today = new Date(); today.setHours(12, 0, 0, 0);
      var arrival = new Date(today.getTime() + lead * 86400000);
      var margin = Math.round((wedding - arrival) / 86400000);
      var weeks = Math.floor(margin / 7);
      if (isNaN(wedding.getTime())) { out.textContent = ''; return; }
      if (margin < 0) {
        out.innerHTML = tx('data-msg-late', 'Ordered today, your gown would arrive around <b>%date%</b> — after your date. Write to us: we will tell you honestly what is possible.').replace('%date%', '<b>' + fmt(arrival) + '</b>').replace('<b><b>', '<b>').replace('</b></b>', '</b>');
        out.className = 'rdv-date-out warn';
      } else if (margin < 21) {
        out.innerHTML = tx('data-msg-tight', 'Ordered today, your gown would arrive around %date%, %n% days before your day. It is close — write to us first, we will confirm the timing.').replace('%date%', '<b>' + fmt(arrival) + '</b>').replace('%n%', margin);
        out.className = 'rdv-date-out warn';
      } else {
        out.innerHTML = tx('data-msg-ok', 'Ordered today, your gown would arrive around %date% — %n% weeks before your day. Time to breathe.').replace('%date%', '<b>' + fmt(arrival) + '</b>').replace('%n%', weeks);
        out.className = 'rdv-date-out ok';
      }
    };
    input.addEventListener('change', update);
    input.addEventListener('input', update);
  });

  /* ── 10. The five measures: lines that light up in turn, or under the pointer ── */
  doc.querySelectorAll('[data-mesures]').forEach(function (sec) {
    var items = Array.prototype.slice.call(sec.querySelectorAll('.ms-item'));
    var groups = Array.prototype.slice.call(sec.querySelectorAll('.mes'));
    if (!items.length || !groups.length) return;
    var idx = -1, timer = null, paused = false, started = false;
    var light = function (key) {
      items.forEach(function (it) { it.classList.toggle('on', it.getAttribute('data-mes') === key); });
      groups.forEach(function (g) { g.classList.toggle('on', g.getAttribute('data-mes') === key); });
      sec.classList.toggle('ms-lit', !!key);
    };
    var next = function () {
      if (paused) return;
      idx = (idx + 1) % items.length;
      light(items[idx].getAttribute('data-mes'));
    };
    var start = function () {
      if (started || reduce) return; started = true;
      setTimeout(function () { next(); timer = setInterval(next, 2600); }, 4200); /* after the drawing */
    };
    items.forEach(function (it) {
      var on = function () { paused = true; idx = items.indexOf(it); light(it.getAttribute('data-mes')); };
      it.addEventListener('mouseenter', on);
      it.addEventListener('focus', on);
      it.addEventListener('click', on);
      it.addEventListener('touchstart', on, { passive: true });
    });
    groups.forEach(function (g) {
      g.style.cursor = 'pointer';
      g.addEventListener('mouseenter', function () {
        paused = true; var k = g.getAttribute('data-mes');
        idx = items.findIndex(function (it) { return it.getAttribute('data-mes') === k; });
        light(k);
      });
    });
    sec.addEventListener('mouseleave', function () { paused = false; });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) { start(); } });
      }, { threshold: 0.3 });
      io.observe(sec);
    } else { start(); }
    if (reduce) { light(items[0].getAttribute('data-mes')); }
  });

  /* ── 9. Buttons: a gold sheen that follows the pointer ── */
  if (fine && ANIM) {
    doc.querySelectorAll('.btn-or, .btn-line').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
      });
    });
  }
})();
